/**
 * Regra do gestor sem cadastro de missão, como o produto sempre a aplicou: o próprio
 * `cad_missao` zerado, ou uma dupla de liderança inteira com `cad_missao` zerado.
 *
 * Mora em `utils` porque governa decisões em telas diferentes — o bloco de ações do dashboard e
 * a barra de abas dos desafios. Enquanto estava embutida em cada JSX, cada tela carregava sua
 * própria cópia da mesma condição de cinco linhas.
 */
export function isGestorSemCadastro(userInfo: any): boolean {
  if (!userInfo) return false;

  if (userInfo.cad_missao === 0) return true;

  return (
    Array.isArray(userInfo.mad_dupla) &&
    userInfo.mad_dupla.length > 0 &&
    userInfo.mad_dupla.every((md: any) => typeof md.cad_missao === 'number' && md.cad_missao === 0)
  );
}
